import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from 'contexts/AuthContext';
import $api from 'http/index';
import styles from './FavoritesPage.module.scss';

// ── Social icons ──────────────────────────────────────────────────────────────
const YouTubeIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
);

const TwitchIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
    </svg>
);

const TelegramIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.883 13.65l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.91z" />
    </svg>
);

const InstagramIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
);

const TwitterIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const TikTokIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z" />
    </svg>
);

const VKIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.862-.523-2.049-1.709-1.033-1.005-1.49-.803-1.49.205v1.504c0 .508-.016.508-1.9.508C9.109 17.631 7.12 16.4 5.733 14.031c-2.008-3.35-2.56-5.85-2.56-6.336 0-.508.204-.98.93-.98H5.85c.69 0 .95.317 1.215 1.065.669 1.932 1.792 3.63 2.256 3.63.173 0 .252-.079.252-.518V9.063c-.063-1.156-.679-1.254-.679-1.665 0-.198.16-.408.426-.408h2.742c.578 0 .786.314.786.99v2.662c0 .582.252.79.41.79.173 0 .346-.208.693-.555 1.065-1.192 1.825-3.03 1.825-3.03.1-.204.31-.39.759-.39h1.744c.534 0 .645.274.534.645-.22 1.015-2.334 4.006-2.334 4.006-.175.291-.238.42 0 .744.173.237.74.73 1.116 1.17.693.79 1.219 1.456 1.36 1.915.142.46-.09.694-.6.694z" />
    </svg>
);

const DiscordIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
);

const WebsiteIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
    </svg>
);

const HeartIcon = ({ filled }) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
);

// ── Social links map ──────────────────────────────────────────────────────────
const SOCIAL_MAP = [
    { key: 'youtube', Icon: YouTubeIcon, color: '#FF0000', label: 'YouTube' },
    { key: 'twitch', Icon: TwitchIcon, color: '#9147FF', label: 'Twitch' },
    { key: 'telegram', Icon: TelegramIcon, color: '#2AABEE', label: 'Telegram' },
    { key: 'instagram', Icon: InstagramIcon, color: '#E1306C', label: 'Instagram' },
    { key: 'twitter', Icon: TwitterIcon, color: '#000000', label: 'X' },
    { key: 'tiktok', Icon: TikTokIcon, color: '#010101', label: 'TikTok' },
    { key: 'vk', Icon: VKIcon, color: '#4C75A3', label: 'ВКонтакте' },
    { key: 'discord', Icon: DiscordIcon, color: '#5865F2', label: 'Discord' },
    { key: 'website', Icon: WebsiteIcon, color: '#6c757d', label: 'Сайт' },
];

// ── FavoriteCard ──────────────────────────────────────────────────────────────
function FavoriteCard({ item, onLike, authRequired }) {
    const presentSocials = SOCIAL_MAP.filter(s => item[s.key]);

    return (
        <div className={styles.card}>
            {/* Photo */}
            <div className={styles.photoWrap}>
                {item.photo ? (
                    <img
                        src={item.photo}
                        alt={item.name}
                        className={styles.photo}
                    />
                ) : (
                    <div className={styles.photoPlaceholder}>
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                    </div>
                )}
            </div>

            <div className={styles.cardBody}>
                <div className={styles.nameRow}>
                    <span className={styles.name}>{item.name}</span>
                    {presentSocials.length > 0 && (
                        <div className={styles.socials}>
                            {presentSocials.map(({ key, Icon, color, label }) => (
                                <a
                                    key={key}
                                    href={item[key]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.socialLink}
                                    title={label}
                                    style={{ background: color }}
                                >
                                    <Icon />
                                </a>
                            ))}
                        </div>
                    )}
                </div>

                {/* Description */}
                {item.description && (
                    <p className={styles.description}>{item.description}</p>
                )}

                {/* Like button */}
                <button
                    className={`${styles.likeBtn} ${item.is_liked ? styles.liked : ''}`}
                    onClick={() => onLike(item)}
                    title={authRequired ? 'Войдите, чтобы поставить лайк' : (item.is_liked ? 'Снять лайк' : 'Мой любимчик')}
                >
                    <HeartIcon filled={item.is_liked} />
                    <span>Мой любимчик</span>
                    <span className={styles.likeCount}>{item.likes_count}</span>
                </button>
            </div>
        </div>
    );
}

// ── FavoritesPage ─────────────────────────────────────────────────────────────
export default function FavoritesPage() {
    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [authPrompt, setAuthPrompt] = useState(false);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const res = await $api.get('favorites/');
            const data = res.data;
            setItems(Array.isArray(data) ? data : (data.results ?? []));
        } catch {
            setError('Не удалось загрузить список любимчиков');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleLike = async (item) => {
        if (!user) {
            setAuthPrompt(true);
            setTimeout(() => setAuthPrompt(false), 3000);
            window.dispatchEvent(new CustomEvent('openAuth'));
            return;
        }
        try {
            const res = await $api.post(`favorites/${item.id}/like/`);
            const { liked, likes_count } = res.data;
            setItems(prev =>
                prev.map(i =>
                    i.id === item.id ? { ...i, is_liked: liked, likes_count } : i
                )
            );
        } catch {
            // silent
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <h1 className={styles.title}>Те, кто вдохновляет. Те, за кем следят. Те, кого мы выбрали.</h1>
             
            </div>

            {authPrompt && (
                <div className={styles.authToast}>
                    Чтобы поставить лайк, пройдите авторизацию
                </div>
            )}

            {loading && (
                <div className={styles.loader}>
                    <div className={styles.spinner} />
                </div>
            )}

            {error && <p className={styles.error}>{error}</p>}

            {!loading && !error && items.length === 0 && (
                <p className={styles.empty}>Здесь пока никого нет...</p>
            )}

            {!loading && !error && items.length > 0 && (
                <div className={styles.grid}>
                    {items.map(item => (
                        <FavoriteCard
                            key={item.id}
                            item={item}
                            onLike={handleLike}
                            authRequired={!user}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
